import script from "./CampaignSlotBooking.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignSlotBooking.vue?vue&type=script&setup=true&lang=js"

import "./CampaignSlotBooking.vue?vue&type=style&index=0&id=2b97566a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b97566a"]])

export default __exports__